<script setup lang='ts'>
import { timeFormat } from '@qctsw/utils'
import type { ComplaintDetailResponse } from '~/server/types'

const props = withDefaults(defineProps<{
  isAuditStatus?: boolean // 是否展示为审核的数据
  data: ComplaintDetailResponse['datumLs']
  isBold?: boolean
  title?: string
}>(), {
  isAuditStatus: false,
  isBold: false,
  title: '车主补充内容',
})

const hasData = computed(() => {
  let statue = false
  for (const item of props.data) {
    // 如果展示审核状态，则将所有数据都展示
    if (props.isAuditStatus
      || (item.datumContent && (item.auditStatusCode === 1))) {
      statue = true
      break
    }
  }
  return statue
})
</script>

<template>
  <div v-if="hasData" class="pui-complaint-supplement">
    <div class="border-1 border-slate-2 rounded-md relative p-sm pt-xl mt-8.5">
      <div class="bg-white absolute -top-4 left-5 px-2 py-1 text-3.5" :class="{ 'font-bold': props.isBold }">
        {{ props.title }}
      </div>
      <template v-for="(v, i) in props.data" :key="i">
        <div v-if="v.datumContent" class="relative mb-sm last:mb-0">
          <slot :item="v" :index="i">
            <div class="text-slate-5 text-3.25 flex items-center">
              <UtilAuditStatus v-if="props.isAuditStatus" :status="v.auditStatusCode" class="text-4 mr-1" />
              <span>{{ timeFormat(v.createTime, 'YYYY-MM-DD HH:mm') }}</span>
            </div>
            <div class="text-slate-9 text-4 tracking-0.5 leading-1.5em mt-2">
              <div v-html="v.datumContent.replace(/\n/g, '<br />')" />
            </div>
          </slot>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.border-top__text {
  padding: 5px 10px;
  background-color: #fff;
  position: absolute;
  top: -18px;
  left: 20px;
}
</style>
